import React from 'react'
import NextLink, { LinkProps } from 'next/link'
import { useRouter } from 'next/router'

interface NextLinkProps extends LinkProps {
  children
}

const preservedQueryParams = [
  'v2',
  'previewMode',
  'previewToken'
]

const getPreservedQueryString = (query: Record<string, any>) => {
  const queries = preservedQueryParams
    .map((param) => query?.[param] ? `${param}=${query[param]}` : null)
    .filter(x => x)
  
  return queries.length === 0 ? '' : `?${queries.join('&')}`
}

const Link = React.memo(({ as, children, ...props }: NextLinkProps) => {
  const router = useRouter()
  const { query } = router

  const parsedHref = React.useMemo(() => {
    const queryString = getPreservedQueryString(query)
    return as ? `${as}${queryString}` : ''
  }, [as, query])

  if (query.previewMode === 'true') {
    return <a href={parsedHref}>
      {children}
    </a>
  }

  return (
    <NextLink as={parsedHref} {...props}>
      {children}
    </NextLink>
  )
})

export default Link
